<ion-item class="question-item" [formGroup]="form">
  <ion-label position="stacked" *ngIf="label">{{ label }}<app-required-asterisk [show]="requiredField" /></ion-label>
  <ion-textarea
    [formControlName]="inputName"
    [ngClass]="{ error: isError }"
    [disabled]="disabled"
    rows="1"
    [autoGrow]="false"
    spellcheck="true"
    autocorrect="on"
    autocapitalize="sentences"
    (keydown.enter)="$event.preventDefault()"
  ></ion-textarea>
</ion-item>
